export const getRealtimeBufferDuration = (): number => 5000;
export const getMaxBufferSize = (): number => 100;
export const isBrowserTabVisible = (): boolean => !document.hidden;
